
import './styles/App.css';
import Header from './components/Header.js'
import Contacts from './components/Contacts.js'
import Socials from './components/Socials.js'
import Agent from './components/Agent.js'
function App() {
  return (

      <>

        <div class='card'>

              <Header/>
              <Contacts/>
              <Socials/>
              <Agent/>







        </div>



      </>



    );
   
}

export default App;
